/* @flow */

export default class SupplierCompanyBankAccount {
    bankAccountID: number;
    bankAccountCountryId: number;
    bankIdentifier: string;
    bankAccount: string;
    hasBankAccountDocument: boolean;
  }
  